import type { ReactNode } from 'react';
import * as Tooltip from '~/components/ui/Tooltip';
import { SPECIAL_TOKENS_NAME } from '~/lib/constants';
import { classNames } from '~/utils/classNames';
import { formatTokens } from '~/utils/format';

interface TokensCountTooltipProps {
  referralTokens: number;
  specialTokens: number;
  color?: string;
  purchasedTokens?: number;
  children?: ReactNode;
}

export const TokensCountTooltip = (props: TokensCountTooltipProps) => {
  const { referralTokens, specialTokens, color, purchasedTokens, children } = props;

  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          {children ? children : <span className={classNames('i-ph:question mt-1', color)} />}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side="bottom" collisionPadding={10} sideOffset={6}>
            <div className="w-60 max-w-screen rounded-md p-3 shadow-lg text-sm">
              <div className="space-y-sm">
                <div className="flex justify-between gap-2">
                  <span>Referral tokens</span>
                  <span className="font-semibold">{formatTokens(referralTokens)}</span>
                </div>
                {purchasedTokens && purchasedTokens > 0 ? (
                  <div className="flex justify-between gap-2">
                    <span>Purchased tokens</span>
                    <span className="font-semibold">{formatTokens(purchasedTokens)}</span>
                  </div>
                ) : null}
                {specialTokens > 0 && (
                  <div className="flex justify-between gap-2">
                    <span>{SPECIAL_TOKENS_NAME} tokens</span>
                    <span className="font-semibold">{formatTokens(specialTokens)}</span>
                  </div>
                )}
              </div>
            </div>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
